import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function solutionamj() {
  return (
    <section className="solution_amj p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>3. Marketplace</h2>
            <p>
              The app has a built-in online store feature. Buyers and sellers
              can exchange comprehensive catalogues of golf products, perform
              quick checkouts, send and receive online payments, track the
              status of their orders and delivery.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/teemates/marketplace.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={875}
              height={570}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default solutionamj;
